/* eslint-disable react/display-name */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { ITextProps } from './interfaces';

const Text = React.forwardRef<HTMLDivElement, ITextProps>(
  ({ children, isBold, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        color="grey.300"
        fontFamily="montserrat"
        fontWeight={isBold ? 'bold' : 'light'}
        cursor="pointer"
        transition="all 320ms ease-in-out"
        _hover={{ color: 'primary' }}
        {...props}
      >
        {children}
      </Box>
    );
  }
);

export default Text;
